/* HN Auth: scroll reveal for the authorized-retailers sections.
   Adds .is-in to every [data-hn-auth-reveal] element as it enters the
   viewport. Elements already on screen at load reveal immediately. Skips
   the effect entirely for reduced-motion users and older browsers. */
(function () {
  if (window.__hnAuthRevealBound) return;
  window.__hnAuthRevealBound = true;

  function init() {
    var els = document.querySelectorAll('[data-hn-auth-reveal]');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            entries[j].target.classList.add('is-in');
            io.unobserve(entries[j].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The theme editor re-renders sections in place; pick up new nodes. */
  document.addEventListener('shopify:section:load', init);
})();
